
'use strict';

import Ajax from '../modules/ajax';
import { makeAutoObservable } from "mobx"
import notification from '../modules/notification';
import setupAddToCart from '../modules/add-to-cart';
import {OjEvent} from '../modules/ojevent';



function updateCartPrices ( cart ) {
    const elem = document.querySelector('.calculations');
    if (!elem) return;

    elem.querySelector('.price.subtotal').innerHTML = cart.totalSub;
    elem.querySelector('.price.shipping').innerHTML = cart.shippingCost;
    elem.querySelector('.price.incl').innerHTML = cart.totalIncl;
    elem.querySelector('.price.excl').innerHTML = cart.totalExcl;

    const shippingRaw = document.querySelector('.price.shipping-raw');
    if ( shippingRaw ) {
        shippingRaw.innerHTML = cart.rawShippingCost;
    }

    const shippingHolder = document.querySelectorAll('.shipping-holder');
    shippingHolder
        .forEach(elem => cart.pickupShipping
            ? elem.classList.add('d-none')
            : elem.classList.remove('d-none'));
}



export default class Product {

    constructor() {
        this.cart = [];
        this.compareProducts = [];
        this.overviewElem = null;
        this.searchElem = null;
        this.removedFavorite = null;

        makeAutoObservable(this);
    };

    setOverview (elem) {
        this.overviewElem = elem;
    };

    setSearch (elem) {
        this.searchElem = elem;
    };

    removeFavorite (id) {
        this.removedFavorite = id;
    };

    calculateCart (postData) {
        Ajax.send({
            sUrl:  '/ajax/cart/calculate',
            sMethod: 'POST',
            aData: postData,
        })
            .then(response => {
                this.updateCartData(response.Cart);
            });
    };

    changeCart (type, product) {
        Ajax.send({
            sUrl:  '/ajax/cart/'+ type,
            sMethod: 'POST',
            aData: {
                csrf_baptist: window.oData.csrf_baptist,
                ...product,
                type: product.type_,
            }
        })
            .then(response => {
                this.updateCartData(response.Cart);

                if ( response.event ) {
                    new OjEvent(
                        response.event.name,
                        response.event.data
                    )
                    .trigger();
                }
            });
    };

    updateCartData (cart) {
        this.cart = cart;
        updateCartPrices(cart);
    };

    addToCart (product) {
        this.changeCart('insert', product);
    };

    updateCart (product) {
        this.changeCart('update', product);
    };

    deleteCartItem (product) {
        this.changeCart('delete', product);
    };

    fetchCompare () {
        return Ajax.send({
            sUrl: '/ajax/products/compare',
            sMethod: 'POST',
            aData: {
                csrf_baptist: window.oData.csrf_baptist,
            }
        })
            .then(response => {
                this.compareProducts = response.products || [];

                setupAddToCart();

                return this.compareProducts;
            });
    };

    compare (id) {
        if ( this.compareProducts.find(product => product.id == id) === undefined ) {
            this.addCompare(id);
        } else {
            this.removeCompare(id);
        }
    };

    addCompare (id) {
        Ajax.send({
            sUrl:  '/ajax/products/addCompare',
            sMethod: 'POST',
            aData: {
                csrf_baptist: window.oData.csrf_baptist,
                id: id
            }
        })
        .then(response => {
            if ( response.succes && response.succes == 1 ) {
                this.fetchCompare();
            } else if ( response.succes == 0 ) {
                notification(g.lang.max_compared_limit_reached, 'warning')
            }
        });
    };

    removeCompare (id) {
        Ajax.send({
            sUrl:  '/ajax/products/deleteCompare',
            sMethod: 'POST',
            aData: {
                csrf_baptist: window.oData.csrf_baptist,
                id: id
            }
        })
        .then(response => {
            if ( response.succes && response.succes == 1 ) {
                this.fetchCompare();
            }
        });
    }
};
